import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import { styled } from '@mui/material';
import { ITableCell } from 'v3/pages/Products/List/types';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { theme } from 'v3/styles/global-styles';

export const MainContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  backgroundColor: theme.palette.primary.main,
  borderRadius: '0.5rem',
  maxHeight: '31rem',
  padding: '2rem 1rem',
  gap: '2rem',
}));

export const AlignValues = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  whiteSpace: 'pre',
}));

export const TableRowName = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.5rem',
}));

export const EditIcon = styled(CreateOutlinedIcon)(() => ({
  cursor: 'pointer',
  display: 'flex',
  paddingBottom: '0.5rem',
}));

export const HeaderLine = styled(SubtitleMedium)(() => ({
  width: '30%',
  whiteSpace: 'pre-wrap',
}));

export const HeaderLineMaxPercentage = styled(SubtitleMedium)(() => ({
  width: '30%',
  whiteSpace: 'pre-wrap',
}));

export const BodyLine = styled(SubtitleMedium)(() => ({
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  display: 'flex',
  flexWrap: 'wrap',
  paddingLeft: '2rem',
}));

export const SubtitleLine = styled(SubtitleMedium)(() => ({
  flexWrap: 'wrap',
  paddingLeft: '2rem',
  color: theme.palette.secondary.main,
}));

export const AlignClientInfo = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '70%',
  gap: '.25rem',
}));

export const AlignSwitch = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '70%',
  paddingLeft: '1rem',
}));

export const AlignSwitchContainer = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  AlignItems: 'center',
}));

export const SeeMoreContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',
}));

export const Line = styled('div')(() => ({
  borderTop: `0.1rem solid ${theme.palette.details.light}`,
  opacity: '0.3',
}));

export const TableCellInRow = styled('div')<ITableCell>(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
}));

export const DeviceImg = styled('img')(() => ({
  width: '5rem',
  paddingLeft: '1rem',
}));

export const StatusContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.5rem',
  paddingLeft: '2rem',
}));

export const StatusTitle = styled(SubtitleMedium)(() => ({
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word',
}));

export const StatusDot = styled('span')<{ color?: string }>(({ color }) => ({
  width: '0.5rem',
  height: '0.5rem',
  borderRadius: '50%',
  backgroundColor: color || theme.palette.secondary.light,
  display: 'inline-block',
  marginRight: '0.5rem',
}));
